import { render, staticRenderFns } from "./Hr.vue?vue&type=template&id=af71420a&scoped=true&"
import script from "./Hr.vue?vue&type=script&lang=js&"
export * from "./Hr.vue?vue&type=script&lang=js&"
import style0 from "./Hr.vue?vue&type=style&index=0&id=af71420a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af71420a",
  null
  
)

export default component.exports